export function useTranslationConfig(): { isTranslationEnabled: boolean } {
  const isTranslationEnabled =
    Preload.current_network.config.translations.deep_l.enabled;

  return { isTranslationEnabled };
}
